import type { IContextMutationResult } from '@modules/core/services/query/types';
import {
  AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS,
} from '@modules/affiliates-approved/submodules/trackers-settings/submodules/trackers-list/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';
import { useToastStore } from '@modules/toast/store';

import type { ISubaffiliateHistoryChangesUpdatePayload } from '../types';
import {
  SUBAFFILIATE_HISTORY_CHANGES_ITEM_QUERY,
  SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_API_URL,
  SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_MUTATION,
} from '../constants';

export default function useSubaffiliateHistoryChangesUpdateMutation(): IContextMutationResult<
  void,
  Error,
  ISubaffiliateHistoryChangesUpdatePayload
> {
  const { fetchPut } = useRestClient();
  const { displayPresetToast } = useToastStore();

  return useContextMutation<void, Error, ISubaffiliateHistoryChangesUpdatePayload>({
    mutationKey: [SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_MUTATION],
    mutationFn: ({ merchant, ...payload }) => fetchPut<void>(
      SUBAFFILIATE_HISTORY_CHANGES_ITEM_UPDATE_API_URL,
      payload,
      {
        permission: AFFILIATES_APPROVED_TRACKERS_LIST_PERMISSIONS.HISTORY_CHANGES_EDIT,
        urlParams: {
          itemId: payload.history_of_subaffiliates_change.id,
        },
        queryParams: { merchant },
      },
    ),
    async onSuccess({ queryClient, variables }) {
      await queryClient.invalidateQueries({ queryKey: [SUBAFFILIATE_HISTORY_CHANGES_ITEM_QUERY, variables.history_of_subaffiliates_change.id] });
      displayPresetToast('edited');
    },
  });
}
